// utils/useVideoJsLoader.ts
let videojsPromise: Promise<any> | null = null

export async function loadVideoJsOnce() {
  if (!videojsPromise) {
    videojsPromise = Promise.all([
      import('video.js'),
      import('@videojs/http-streaming'),
      import('video.js/dist/video-js.css'),
    ]).then(([videojs]) => videojs.default)
  }
  return videojsPromise
}
